(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-stock-progress-joyeria"] && !Shopify.designMode) return;
  try {
    
(function () {
  function clamp(value, min, max) {
    if (value < min) return min;
    if (value > max) return max;
    return value;
  }

  function storageKey(root) {
    return 'stock-progress-' + root.getAttribute('data-section-id');
  }

  function computePercent(root) {
    var mode = root.getAttribute('data-mode');

    if (mode === 'fixed') {
      var fixed = parseFloat(root.getAttribute('data-percent'));
      if (isNaN(fixed)) fixed = 70;
      return clamp(Math.round(fixed), 1, 99);
    }

    var start = parseFloat(root.getAttribute('data-start-percent'));
    var end = parseFloat(root.getAttribute('data-end-percent'));
    var minutes = parseFloat(root.getAttribute('data-duration-minutes'));

    if (isNaN(start)) start = 60;
    if (isNaN(end)) end = 92;
    if (isNaN(minutes) || minutes <= 0) minutes = 30;
    if (end < start) end = start;

    var key = storageKey(root);
    var state = null;

    try {
      state = JSON.parse(localStorage.getItem(key));
    } catch (e) {}

    if (!state || typeof state.startedAt !== 'number' || typeof state.base !== 'number') {
      var base = start;

      if (root.getAttribute('data-jitter') === '1') {
        base = start + (Math.random() * 6 - 3);
      }

      state = { startedAt: Date.now(), base: clamp(base, 1, 99) };

      try {
        localStorage.setItem(key, JSON.stringify(state));
      } catch (e) {}
    }

    var elapsed = Date.now() - state.startedAt;
    var ratio = clamp(elapsed / (minutes * 60 * 1000), 0, 1);
    var value = state.base + (end - state.base) * ratio;

    return clamp(Math.round(value), 1, 99);
  }

  function render(root, percent, animate) {
    var fill = root.querySelector('[data-stock-progress-fill]');
    var status = root.querySelector('[data-stock-progress-status]');
    var track = root.querySelector('[data-stock-progress-track]');
    if (!fill) return;

    fill.style.setProperty('--stkp-value', percent + '%');

    if (animate) {
      fill.classList.remove('is-active');
      // Reflow: fuerza a que la animación vuelva a arrancar desde cero
      void fill.offsetWidth;
      fill.classList.add('is-active');
    } else {
      fill.classList.remove('is-active');
      fill.style.width = percent + '%';
    }

    if (track) {
      track.setAttribute('aria-valuenow', String(percent));
    }

    if (status) {
      var template = root.getAttribute('data-status-template') || '';
      status.textContent = template.replace('{porcentaje}', percent);
    }
  }

  function initRoot(root) {
    if (root.getAttribute('data-stock-progress-ready') === 'true') return;
    root.setAttribute('data-stock-progress-ready', 'true');

    var fill = root.querySelector('[data-stock-progress-fill]');
    var started = false;

    function start() {
      if (started) return;
      started = true;

      var percent = computePercent(root);
      render(root, percent, true);

      if (fill) {
        fill.addEventListener('animationend', function () {
          fill.classList.remove('is-active');
          fill.style.width = percent + '%';
        }, { once: true });
      }

      if (root.getAttribute('data-mode') !== 'fixed') {
        setInterval(function () {
          render(root, computePercent(root), false);
        }, 15000);
      }
    }

    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            start();
            observer.disconnect();
          }
        }
      }, { rootMargin: '0px 0px -10% 0px' });
      observer.observe(root);
    } else {
      start();
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-stock-progress]');
    for (var i = 0; i < roots.length; i++) {
      initRoot(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-urgency-banner-joyeria"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function storageKey(banner) {
    return 'urgency-banner-' + banner.getAttribute('data-section-id');
  }

  function formatDiff(ms) {
    if (ms < 0) ms = 0;
    var totalSeconds = Math.floor(ms / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    if (hours > 0) {
      return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    }
    return pad(minutes) + ':' + pad(seconds);
  }

  function resolveEnd(banner) {
    var mode = banner.getAttribute('data-timer-mode');

    if (mode === 'date') {
      var raw = (banner.getAttribute('data-end-date') || '').trim();
      if (!raw) return null;
      var parsed = new Date(raw.replace(' ', 'T')).getTime();
      if (isNaN(parsed)) parsed = new Date(raw).getTime();
      if (isNaN(parsed)) return null;
      return parsed;
    }

    var minutes = parseFloat(banner.getAttribute('data-duration-minutes'));
    if (isNaN(minutes) || minutes <= 0) minutes = 17;
    var duration = minutes * 60 * 1000;
    var key = storageKey(banner);
    var stored = null;

    try {
      stored = parseInt(localStorage.getItem(key), 10);
    } catch (e) {}

    if (stored && !isNaN(stored)) {
      // Si el guardado quedó fuera de rango (cambiaste la duración), se regenera
      if (stored - Date.now() <= duration) {
        return stored;
      }
    }

    var end = Date.now() + duration;
    try {
      localStorage.setItem(key, String(end));
    } catch (e) {}
    return end;
  }

  function initBanner(banner) {
    if (banner.getAttribute('data-urgency-ready') === 'true') return;
    banner.setAttribute('data-urgency-ready', 'true');

    var display = banner.querySelector('[data-urgency-timer]');
    if (!display) return;

    var end = resolveEnd(banner);
    if (!end) {
      display.textContent = '00:00';
      return;
    }

    var onExpire = banner.getAttribute('data-on-expire');
    var expiredText = banner.getAttribute('data-expired-text') || '';
    var interval = null;

    function handleExpired() {
      if (interval) clearInterval(interval);

      if (onExpire === 'hide') {
        banner.style.display = 'none';
        return;
      }

      if (onExpire === 'restart') {
        try {
          localStorage.removeItem(storageKey(banner));
        } catch (e) {}
        banner.removeAttribute('data-urgency-ready');
        initBanner(banner);
        return;
      }

      if (onExpire === 'text' && expiredText) {
        display.textContent = expiredText;
        return;
      }

      display.textContent = '00:00';
    }

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        display.textContent = '00:00';
        handleExpired();
        return;
      }
      display.textContent = formatDiff(diff);
    }

    interval = setInterval(tick, 1000);
    tick();
  }

  function initAll(root) {
    var scope = root || document;
    var banners = scope.querySelectorAll('[data-urgency-banner]');
    for (var i = 0; i < banners.length; i++) {
      initBanner(banners[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
